import http from "../../http";

/** 缴费退款申请 — /resident/api/resident/housePaymentRefundApply */
const BASE = "/resident/api/resident/housePaymentRefundApply";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  statusCount(r) {
    return http.get(`${BASE}/statusCount`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  /** 通过：服务端 adminRefund（在线走 merchant unifiedRefund） */
  approve(r) {
    return http.tip.payload(`${BASE}/approve`, r);
  },
  reject(r) {
    return http.payload(`${BASE}/reject`, r);
  },
};
